module.exports = "<p>\r\n  reseller-signup works!\r\n</p>\r\n"